document.addEventListener("DOMContentLoaded", function() {
    if(document.querySelector('.contact-info__text')) {
        gsap.from(".contact-info__text, .contact-info__item--phone, .contact-info__item--email", {
            y: "100%",   
            opacity: 0,   
            duration: 1.5,  
            ease: "power4.out",       
        });
    }
});


document.addEventListener("DOMContentLoaded", function() {
    gsap.registerPlugin(ScrollTrigger);
    if(document.querySelector('.contact-address__item')) {

        gsap.from(".contact-address__item", {
            scrollTrigger: {
                trigger: ".contact-address__item",
                start: "top 95%",  
                end: "bottom 20%",  
                toggleActions: "play none none none", 
            },
            y: "100%",       
            opacity: 0,      
            duration: 2,    
            ease: "power4.out",   
        });
    }
    if(document.querySelector('.contact-address__item--address')) {

        gsap.from(".contact-address__item--address", {
            scrollTrigger: {
                trigger: ".contact-address__item",
                start: "top 90%",  
                end: "bottom 10%",  
                toggleActions: "play none none none", 
            },
            y: "50%",       
            opacity: 0,      
            duration: 1.5,    
            ease: "power4.out",   
        });
    }
    if(document.querySelector('.contact-address__item--name')) {

        gsap.from(".contact-address__item--name", {
            scrollTrigger: {
                trigger: ".contact-address__item",
                start: "top 90%",  
                end: "bottom 10%",  
                toggleActions: "play none none none", 
            },
            y: "50%",       
            opacity: 0,      
            duration: 1.5,    
            ease: "power4.out",   
        });
    }
    if(document.querySelector('.main-default .form-contact__wrapper'))  {

        gsap.from('.main-default .form-contact__wrapper', {
          y: 100,       
          opacity: 0,  
          duration: 2, 
          ease: "power2.out",  
          scrollTrigger: {
            trigger: '.form-contact',  
            start: 'top 80%',         
            toggleActions: 'play none none none' 
          }
        });
    }
});


